import { useEffect, useRef } from "react";

/**
 * 「重新查询」按钮这类场景：调用方维护一个递增的 token，token 变化时强制 refetch 一次。
 * 首次挂载不触发（初次请求由 useQuery 自己负责），避免双发。
 */
export function useRefetchOnToken(refetch: () => unknown, token: number | undefined) {
  const prevToken = useRef(token);
  useEffect(() => {
    if (prevToken.current === token) return;
    prevToken.current = token;
    void refetch();
  }, [token, refetch]);
}
